/**
 * home-reveal.js — homepage scroll behaviour: the per-section reveal, pausing
 * the hero currents off screen, the trailing CTA pill, and the contact
 * section's arrival.
 *
 * Progressive enhancement: the hidden initial state is applied by JS only
 * (via the `home-reveal` class), so sections stay visible when JS is off.
 * The hero (first section, above the fold) is left visible to avoid a flash.
 * An IntersectionObserver adds `is-revealed` as each section enters view.
 * The fade/translate itself is handled in CSS, which also opts out under
 * prefers-reduced-motion.
 */
(function () {
    if (!document.body.classList.contains('home-template')) return;

    var sections = document.querySelectorAll('#main > section');
    if (!sections.length) return;

    // If IntersectionObserver is unavailable, leave everything visible.
    if (!('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (entry) {
            if (entry.isIntersecting) {
                entry.target.classList.add('is-revealed');
                obs.unobserve(entry.target);
            }
        });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.1 });

    // Sections excluded from the reveal, by class (not index, so this stays
    // correct if the section order changes):
    // - home-hero: above the fold, must not flash hidden.
    // - home-untangle: home-marble.js pins its stage (and phones use a
    //   sticky art band). A `transform` on an ancestor (the reveal's
    //   translateY) creates a containing block that breaks both.
    // - home-contact: has its own is-armed/is-arrived arrival animation;
    //   stacking home-reveal on top would double up the effect.
    var SKIP = 'home-hero home-untangle home-contact'.split(' ');

    sections.forEach(function (section) {
        for (var i = 0; i < SKIP.length; i++) {
            if (section.classList.contains(SKIP[i])) return;
        }
        section.classList.add('home-reveal');
        observer.observe(section);
    });

    var hero = document.querySelector('.home-hero');
    var currents = document.querySelector('.home-hero-currents');
    var pill = document.querySelector('.home-follow-cta');
    var contact = document.getElementById('contact');

    // フォロー用の CTA ピル。ヒーローを抜けてから contact に着くまでの間だけ出す。
    // ヒーローと contact の IntersectionObserver の結果を毎回 AND で合成する
    // （どちらが先に発火するかは保証されないため、状態は都度計算し直す）。
    var pastHero = false;
    var atContact = false;
    var updatePill = function () {
        if (pill && contact) pill.classList.toggle('is-on', pastHero && !atContact);
    };

    // ヒーローの監視は 1 つで、currents の一時停止とピルの両方に使う。
    // currents はヒーロー全面を覆うので、見えている範囲は同じ。
    // currents は画面外にある間だけ止める。stroke-dashoffset はコンポジタで
    // 動かせないため、動いている間はヒーロー全面のラスタを毎フレーム描き直す。
    // トップページは6セクションあり、ヒーローが見えているのは最初だけ。
    // 止めても見た目は変わらない。
    if (hero && (currents || pill)) {
        new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                pastHero = !entry.isIntersecting;
                if (currents) currents.classList.toggle('is-paused', pastHero);
            });
            updatePill();
        }, { threshold: 0 }).observe(hero);
    }

    if (pill && contact) {
        new IntersectionObserver(function (entries) {
            entries.forEach(function (entry) {
                atContact = entry.isIntersecting;
            });
            updatePill();
        }, { threshold: 0.05 }).observe(contact);
    }

    // Contact セクションの到着演出。青いプレートは CSS 側で scaleY(1) が
    // デフォルト（JS オフでも正しい静的な見た目）。is-armed で scaleY(0) に
    // 畳んだ状態にし、ビューポートに入ったところで is-arrived を足して開く。
    if (contact) {
        contact.classList.add('is-armed');

        var contactObserver = new IntersectionObserver(function (entries, obs) {
            entries.forEach(function (entry) {
                if (entry.isIntersecting) {
                    contact.classList.add('is-arrived');
                    obs.unobserve(entry.target);
                }
            });
        }, { threshold: 0.35 });
        contactObserver.observe(contact);
    }
})();
